<template>
  <div>
    <md-dialog
      :md-active="formShow"
      class="md-scrollbar small-dialog"
    >
      <div class="table-data__tool mb-1">
        <md-dialog-title class="able-data__tool-left">{{ formTitle }}</md-dialog-title>
      </div>

      <md-content class="md-scrollbar" style="overflow: auto;">
        <template v-if="loading">
          <div class="d-flex justify-content-center align-items-center" style="min-height: 150px; ">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </template>
        <template v-else>
          <fieldset :disabled="formMode === 'view'">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal p-3">

              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="type" class="form-control-label" v-required>Type</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="type"
                    name="type"
                    placeholder
                    class="form-control"
                    v-model="input.type"
                    readonly
                  >
                </div>
              </div>

              <div class="row form-group" v-if="input.type == 'OUT'">
                <div class="col col-md-3">
                  <label for="customer" class="form-control-label" v-required>Customer</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="customer"
                    name="customer"
                    placeholder
                    class="form-control"
                    v-model="input.customer"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="stock" class="form-control-label" v-required>Quantity</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="number"
                    id="stock"
                    name="stock"
                    placeholder
                    class="form-control"
                    v-model="input.stock"
                  >
                </div>
              </div>
              
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="journal" class="form-control-label">Journal</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="customer"
                    name="customer"
                    placeholder
                    class="form-control"
                    v-model="input.journal"
                  >
                </div>
              </div>
              <div class="row form-group" v-if="input.type == 'IN'">
                <div class="col col-md-3">
                  <label for="attachments" class="form-control-label">Attachments</label>
                </div>
                <div class="col-12 col-md-9">
                  <div v-for="(item, key) in input.attachmentURLs" class="imagePreview" :style="{'background-image': 'url(' + item + ')'}">
                    <a :href="item" target="_blank"></a>
                    <button type="button" class="removeImage" v-on:click="removeImage(key)"><i class="fas fa-times"></i></button>
                  </div>
                  <div v-for="(item, key) in input.files">
                    <input type="file" :id="'file_' + key" accept="image/*" ref="file" v-on:change="handleFileUpload(key)"/>
                    <button type="button" v-on:click="removeImageUpload(key)" v-if="item !== null"><i class="fas fa-times"></i></button>
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="save()"
              v-if="formMode != 'view'"
            >Save</md-button>
            <md-button class="md-primary" @click="$emit('closeEdit')">Cancel</md-button>
          </md-dialog-actions>
        </template>
      </md-content>
    </md-dialog>
  </div>
</template>

<script>

import save from 'src/global/save.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import StockHistoryModel from './model/StockHistory'

export default {
  name: 'StockHistoryEdit',
  props: {
    stockType: String,
    formMode: String,
    formShow: Boolean,
    selectedVendorProject: Object,
    selectedItem: Object,
  },
  data() {
    return { 
      input: StockHistoryModel(),
      requiredInput: [
        {key: 'stock', title: 'Quantity'},
        {key: 'type', title: 'Type'},
      ],
      edit: false,
      datas: null,
      processing: false,
      loading: false,
      modelID: null,
      typeOptions: ['IN', 'OUT'],
    }
  },
  computed: {
    formTitle: function () {
      if (this.selectedVendorProject)
        return 'Add new record in ' + this.selectedVendorProject.ref_no
    }
  },
  watch: {
    formShow: function() {
      this.input = StockHistoryModel()
    },
    stockType: function(t) {
      this.input.type = t
    },
    selectedItem: function (data) {
      if (data) {
        this.modelID = data.id
        this.$http
          .get(this.WebService.samplestock + '/' + data.id)
          .then((res) => {
            this.input = res.data.data
            this.$set(this.input, 'files', [null])
          })
      } else {
        this.input = StockHistoryModel()
      }
      console.log('e')
    },
  },
  methods: {
    validation,
    handleFileUpload(key) {
      this.input.files[key] = this.$refs.file[key].files[0]
      if( typeof this.$refs.file[key].files[0] !== 'undefined')
        this.input.files.push(null)
    },
    removeImageUpload(key) {
      this.$refs.file[key].value = ''
      this.input.files.splice(key, 1)

    },
    removeImage(key) {
      this.input.attachments.splice(key, 1)
      this.input.attachmentURLs.splice(key, 1)
    },
    save() {

      if( this.processing !== false ) return

      if( typeof this.validation !== 'undefined' && this.validation() ) {

        this.processing = true

        this.input.vendor_project_id = this.selectedVendorProject.vendorproject.id

        var formData = new FormData();
        
        for ( var key in this.input ) {
          if(key == 'files') continue
          if(this.input[key] == null) continue
          formData.append(key, this.input[key])
        }

        for ( var key in this.input.files ) {
          if( this.input.files[key] )
            formData.append('files[]', this.input.files[key])
        }
        
        if (this.input.id) {

          formData.append('_method', 'PUT')
          this.$http
            .post(this.WebService.samplestock + '/' + this.input.id, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((res) => {
              this.processing = false
              this.input = res.data
              this.$emit('closeEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        } else {

          

          this.$http
            .post(this.WebService.samplestock, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((res) => {
              this.$emit('closeEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        }
      }
    },
  }
}
</script>
<style scoped>
.imagePreview { width: 80px; height: 80px; display: inline-block; margin-right: 10px; margin-bottom: 10px; background-position: center center; background-size: contain; position: relative; }
.imagePreview a { display: block; height: 80px;}
.removeImage { position: absolute; top: 0; right: 0; }
</style>
